import { useEffect } from 'react';

import { useGetTeacherClassesQuery } from 'shared/api/onboarding';
import { useAppDispatch } from 'shared/lib/redux';

import { getRelevantAndSortedClasses } from '../lib';

import { setAllClasses, useAvailableClasses } from './classes-slice';

export const useClasses = () => {
  const dispatch = useAppDispatch();

  const { data: teacherClasses = [], isFetching } = useGetTeacherClassesQuery();

  const classes = useAvailableClasses();

  useEffect(() => {
    if (classes || isFetching) return;

    const availableClasses = getRelevantAndSortedClasses(teacherClasses);

    dispatch(setAllClasses(availableClasses));
  }, [classes, dispatch, isFetching, teacherClasses]);

  return { isFetching, classes };
};
